/*
Copyright 2024 New Vector Ltd.
Copyright 2022 The Matrix.org Foundation C.I.C.

SPDX-License-Identifier: AGPL-3.0-only OR GPL-3.0-only
Please see LICENSE files in the repository root for full details.
*/

export enum UseCase {
    PersonalMessaging = "PersonalMessaging",
    WorkMessaging = "WorkMessaging",
    CommunityMessaging = "CommunityMessaging",
    Skip = "Skip",
}
